(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eastgardens-warehouses"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.__egInit) return; root.__egInit = true;
    var track = root.querySelector('.eg-wh__track');
    var slides = root.querySelectorAll('.eg-wh__slide');
    var dots = root.querySelectorAll('.eg-wh__dot');
    var total = slides.length; if(total < 2) return;
    var idx = 0, timer = null;
    function go(n){
      idx = (n + total) % total;
      track.style.transform = 'translateX(' + (-idx * 100) + '%)';
      dots.forEach(function(d,i){ d.classList.toggle('is-active', i===idx); });
      slides.forEach(function(s,i){ s.classList.toggle('is-active', i===idx); });
    }
    var prev = root.querySelector('[data-eg-prev]');
    var next = root.querySelector('[data-eg-next]');
    if(prev) prev.addEventListener('click', function(){ go(idx-1); restart(); });
    if(next) next.addEventListener('click', function(){ go(idx+1); restart(); });
    dots.forEach(function(d){ d.addEventListener('click', function(){ go(parseInt(d.getAttribute('data-eg-dot'),10)); restart(); }); });
    function start(){
      if(root.getAttribute('data-autoplay') !== 'true') return;
      var iv = parseInt(root.getAttribute('data-interval'),10) || 5000;
      timer = setInterval(function(){ go(idx+1); }, iv);
    }
    function restart(){ if(timer){ clearInterval(timer); } start(); }
    root.addEventListener('mouseenter', function(){ if(timer) clearInterval(timer); });
    root.addEventListener('mouseleave', function(){ restart(); });
    go(0); start();
  }
  function boot(){ document.querySelectorAll('[data-eg-carousel]').forEach(init); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
